import { Divider, Grid2 as Grid, Grid2Props as GridProps, Typography, TypographyProps, useTheme } from "@mui/material"
import { useStyles } from "./styles"

interface CustomTypographyProps extends Omit<TypographyProps, "gutterBottom"> {
    disableGutter?: boolean
    gutterBottom?: "sm" | "md" | "lg"
    disabled?: boolean
}

const CustomTypography = ({
    children,
    className,
    disableGutter,
    gutterBottom = "md",
    disabled,
    ...props
}: CustomTypographyProps) => {
    const { classes, cx } = useStyles()

    return (
        <Typography
            color={disabled ? "textSecondary" : "textPrimary"}
            className={cx({ [classes[`gutterBottom__${gutterBottom}`]]: !disableGutter }, className)}
            {...props}
        >
            {children}
        </Typography>
    )
}

export const Title = (props: CustomTypographyProps) => <CustomTypography variant="h5" {...props} />

export const PrimaryLabel = (props: CustomTypographyProps) => <Label sx={{ textDecoration: "underline" }} {...props} />
export const Label = (props: CustomTypographyProps) => <CustomTypography variant="h6" {...props} />

export const Body = (props: CustomTypographyProps) => <CustomTypography variant="body1" {...props} />

export const UnderlinedBody = (props: CustomTypographyProps) => (
    <CustomTypography sx={{ textDecoration: "underline" }} {...props} />
)

export const Subtitle2 = (props: CustomTypographyProps) => (
    <CustomTypography variant="subtitle2" color="textSecondary" {...props} />
)

export const BoldBody = ({ children, ...props }: CustomTypographyProps) => (
    <Body {...props} sx={{ fontWeight: "bold" }}>
        {children}
    </Body>
)

interface LabelAndTextProps extends GridProps {
    label: string
    LabelProps?: TypographyProps
    showDivider?: boolean
}

export const LabelAndText = ({
    label,
    children,
    showDivider = true,
    LabelProps,
    sx = [],
    ...props
}: LabelAndTextProps) => {
    const theme = useTheme()
    return (
        <Grid
            container
            sx={{
                display: "flex",
                flex: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                whiteSpace: "break-spaces",
                ...sx,
            }}
            {...props}
        >
            <Grid>
                <Typography
                    sx={{
                        pr: 2,
                        color: theme.palette.primary.main,
                        background: theme.palette.background.paper,
                    }}
                    fontWeight={"bold"}
                    {...LabelProps}
                >
                    {label}
                </Typography>
            </Grid>
            <Grid sx={{ display: showDivider ? "block" : "none", flexGrow: 1 }}>
                <Divider />
            </Grid>
            <Grid>
                <Typography
                    sx={{
                        pl: 2,
                        background: theme.palette.background.paper,
                    }}
                >
                    {children}
                </Typography>
            </Grid>
        </Grid>
    )
}
